import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { Label } from "@/components/Form/Base/label.component";
import { Tooltip } from "@/components/General/Tooltip/tooltip.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type FieldLabelProps = {
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    optionalIndication?: boolean;
    requiredIndication?: boolean;
    name: string;
    tooltip?: { title: string; body: string };
    className?: string;
    children?: ReactNode;
};

const FieldLabel = ({
    hideLabel,
    label,
    optionalIndication = false,
    requiredIndication = true,
    required,
    name,
    tooltip,
    className,
    children
}: FieldLabelProps) => {
    const { t } = useGranite();

    if (!label) {
        return null;
    }
    return (
        <Label
            htmlFor={name}
            hidden={hideLabel}
            className={cn("tw:block", className)}
        >
            <span>
                {children && children}
                {!children && (
                    <span dangerouslySetInnerHTML={{ __html: label }}></span>
                )}{" "}
                {required
                    ? requiredIndication && "*"
                    : optionalIndication && (
                          <span className={cn("small", "tw:italic")}>
                              {t("form.input.optional")}
                          </span>
                      )}
            </span>
            {tooltip && (
                <Tooltip
                    className={cn("tw:inline-flex")}
                    title={tooltip?.title}
                    innerHTML={tooltip?.body}
                />
            )}
        </Label>
    );
};

export { FieldLabel };
